module.exports = __webpack_public_path__ + "static/img/cs2.457460e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/pic/cs2.jpg
// module id = 0st7
// module chunks = 11